/**
 * カレンダー週切り替え
 * PC: 13日表示・13日単位で切り替え
 * SP: 7日（1週間）表示・1週単位で切り替え
 */

const BP_MD = 768; // @include md の閾値

class InputCalendar {
    constructor(root) {
        this.root    = root;
        this.cols    = Array.from(root.querySelectorAll('.c-forms-input-calendar-col'));
        this.btnPrev = root.querySelector('.js-calendar-prev');
        this.btnNext = root.querySelector('.js-calendar-next');

        // ブレークポイント監視（offset計算より先に設定）
        this.mq = window.matchMedia(`(max-width: ${BP_MD}px)`);
        this.mq.addEventListener('change', () => {
            this.offset = 0;
            this.render();
        });

        // チェック済み日付のページを初期オフセットにする
        const checkedIndex = this.cols.findIndex(
            (col) => col.querySelector('.c-forms-input-calendar-col__radio:checked')
        );
        this.offset = checkedIndex >= 0 ? Math.floor(checkedIndex / this.step()) : 0;

        this.btnPrev.addEventListener('click', () => {
            this.offset = Math.max(0, this.offset - 1);
            this.render();
        });

        this.btnNext.addEventListener('click', () => {
            this.offset = Math.min(this.maxOffset(), this.offset + 1);
            this.render();
        });

        this.render();
    }

    // SP判定
    isSp() {
        return this.mq.matches;
    }

    // 表示する日数（SP: 7日 / PC: 13日）
    visibleCount() {
        return this.isSp() ? 7 : 13;
    }

    // 1回の切り替えで進む日数（表示日数と同じ）
    step() {
        return this.visibleCount();
    }

    // 最大オフセット値
    maxOffset() {
        return Math.max(0, Math.ceil((this.cols.length - this.visibleCount()) / this.step()));
    }

    // 表示を更新する
    render() {
        const start = this.offset * this.step();
        const end   = start + this.visibleCount();

        this.cols.forEach((col, i) => {
            col.toggleAttribute('data-hidden', i < start || i >= end);
        });

        this.btnPrev.disabled = this.offset === 0;
        this.btnNext.disabled = this.offset >= this.maxOffset();
    }
}

const main = () => {
    document.querySelectorAll('.c-forms-input-calendar').forEach((root) => {
        new InputCalendar(root);
    });
};

export default main;
